import { CircularProgress, Paper } from "@material-ui/core";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";

import { getRequest } from "../../../api/apiCaller";
import Dialog from "../../../components/Dialog";
import { SWITCHBOARD_GROUPS } from "../../../constant";
import API_URL from "../../../constant/api-url";
import datetimeHelper from "../../../helper/datetime-helper";
import SearchBar from "./SearchBar";
import TableReportInboundOutboundCalls from "./TableReportInboundOutboundCalls";

const ReportInboundOutboundCallls = () => {
  const [filter, setFilter] = useState(null);
  const [loadingExportExcel, setLoadingExportExcel] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleSearch = (searchValues) => {
    const callType = searchValues.callType;
    const city = searchValues.city?.code;
    const district = searchValues.district?.code;
    const subOrg = searchValues.subOrg?.code;

    const phoneNumbers =
      searchValues.phoneNumbers?.length > 0 ? searchValues.phoneNumbers : null;

    const extensionId = searchValues.extension?.id;
    const switchboardGroup = searchValues.switchboardGroup;

    const and = [
      {
        startedAt: {
          gte: datetimeHelper.toFormat(
            searchValues.startDate,
            "YYYY-MM-DD startDay"
          ),
        },
      },
      {
        startedAt: {
          lte: datetimeHelper.toFormat(
            searchValues.endDate,
            "YYYY-MM-DD endDay"
          ),
        },
      },
    ];

    const where = {
      and,
      ...(city && !district && !subOrg && { city }),
      ...(district && !subOrg && { district }),
      ...(subOrg && { subOrg: { inq: [subOrg] } }),
      ...(phoneNumbers && {
        [callType === "inbound" ? "toNumber" : "from"]: { inq: phoneNumbers },
      }),
      ...(extensionId && { extensionId }),
    };
    setFilter({
      page: 0,
      where,
      callType,
      switchboardGroup,
    });
  };

  const searchForm = useFormik({
    initialValues: {
      callType: "inbound", // loại cuộc gọi: inbound hoặc outbound
      startDate: new Date(),
      endDate: new Date(),
      city: null,
      district: null,
      subOrg: null,
      switchboardGroup: SWITCHBOARD_GROUPS[0].id,
      phoneNumbers: [],
      extension: null,
    },
    onSubmit: handleSearch,
  });

  useEffect(() => {
    setFilter(null);
    searchForm.resetForm();
    searchForm.setFieldValue("callType", searchForm.values.callType);
  }, [searchForm.values.callType]);

  const handleExportFile = async () => {
    if (filter?.callType) {
      setLoadingExportExcel(true);
      try {
        let url = "";
        let query = "exportvnpost";
        switch (filter.callType) {
          case "inbound":
            url = API_URL.CLOUD_PBX_INBOUND_CALL_EXPORT;
            break;
          case "outbound":
            url = API_URL.CLOUD_PBX_OUTBOUND_CALL_EXPORT;
            query = "export2";
            break;
          default:
            break;
        }
        const reportOutboundCalls = await getRequest(url, {
          filter: {
            order: "startedAt DESC",
            where: {
              ...filter.where,
            },
          },
          query: query,
          ...(filter.switchboardGroup && {
            type: filter.switchboardGroup,
          }),
        });
        if (reportOutboundCalls.data?.fileUrl) {
          const fileName = reportOutboundCalls.data.fileUrl.split("/").pop();
          saveAs(reportOutboundCalls.data.fileUrl, fileName);
        }
      } catch (err) {
        enqueueSnackbar(
          `${
            err.response?.data?.error?.message || err.message || "Có lỗi xảy ra"
          }`,
          {
            variant: "error",
          }
        );
      }
      setLoadingExportExcel(false);
    }
  };

  return (
    <>
      <Paper style={{ color: "black", padding: 16, marginBottom: 16 }}>
        <SearchBar searchForm={searchForm} onClickExport={handleExportFile} />
      </Paper>

      {filter !== null && (
        <TableReportInboundOutboundCalls reportCallsFilter={filter} />
      )}

      <Dialog open={loadingExportExcel} title={<CircularProgress />} />
    </>
  );
};

export default ReportInboundOutboundCallls;
